import { render, staticRenderFns } from "./CargoMaintenance.vue?vue&type=template&id=047ce174&scoped=true&"
import script from "./CargoMaintenance.vue?vue&type=script&lang=js&"
export * from "./CargoMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./CargoMaintenance.vue?vue&type=style&index=0&id=047ce174&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047ce174",
  null
  
)

export default component.exports